import React from "react";
import { action, makeObservable, observable } from "mobx";

// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export interface IModalInstance<T extends {} = any> {
  children?: React.ReactNode;
  closeModal: (value?: T) => void;
}

export type closeModal<T extends IModalInstance> = Parameters<T["closeModal"]>[0];

export class Modal<T extends IModalInstance> {
  public promise: Promise<closeModal<T>>;
  public resolve?: (value: closeModal<T>) => void;

  constructor(
    public Component: React.FC<T>,
    public props: Omit<T, "closeModal">,
    public close: (value: Parameters<T["closeModal"]>[0]) => void
  ) {
    this.promise = new Promise((resolve) => {
      this.resolve = resolve;
    });
  }
}

export class ModalService {
  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  modalInstances: Modal<any>[] = [];

  constructor() {
    makeObservable(this, {
      modalInstances: observable.shallow,
      openModal: action,
    });
  }

  //eslint-disable-next-line @typescript-eslint/no-explicit-any
  openModal<T extends IModalInstance>(Component: React.FC<T>, props: Omit<T, "closeModal"> = {} as any) {
    const modal = new Modal<T>(
      Component,
      props,
      action((value) => {
        modal.resolve?.(value);
        const index = this.modalInstances.indexOf(modal);
        if (index !== -1) {
          this.modalInstances.splice(index, 1);
        }
      })
    );

    this.modalInstances.push(modal);
    return modal;
  }

  closeModals() {
    this.modalInstances = [];
  }
  hasOpenModals() {
    return this.modalInstances.length > 0;
  }
}

export const modalService = new ModalService();
